export default "__VITE_ASSET__mFKk_Rcf__";